import React, { useMemo } from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { SimpleModal } from '../../../../../components/simple-modal';
import { ApiVersion } from '../constants';
import { messages } from './messages';
import style from './style.module.less';

/**
 * ConfirmModal component. Renders a confirmation modal when trying to regenerate V1 API Keys or delete V2 Keys
 * @param {object} props
 * @param {string} props.apiVersion - Version of the API Key.
 * @param {boolean} [props.actionButtonDisabled] - Flag to disable the action button
 * @param {import('ui-components/components/button').ButtonClickHandler} props.onConfirm - Callback when the user clicks the Delete button.
 * @param {import('../../../../../components/simple-modal/simple-modal').ModalCloseHandler} props.onClose - Callback when the user clicks the Close and Cancel buttons.
 * @returns {JSX.Element} The rendered component.
 */
export const ConfirmModal = ({ apiVersion, actionButtonDisabled = false, onConfirm, onClose }) => {
  const modalMessages = useMemo(() => {
    if (apiVersion === ApiVersion.V1) {
      return {
        modalTitle: messages.v1ModalTitle,
        bodyTitle: messages.v1ModalBodyTitle,
        bodyContent: messages.v1ModalBodyContent,
        actionMessage: messages.v1ActionMessage,
      };
    }

    return {
      modalTitle: messages.v2ModalTitle,
      bodyTitle: messages.v2ModalBodyTitle,
      bodyContent: messages.v2ModalBodyContent,
      actionMessage: messages.v2ActionMessage,
    };
  }, [apiVersion]);

  return (
    <SimpleModal
      actionButtonTheme='danger'
      actionMessage={modalMessages.actionMessage}
      cancelMessage={messages.modalCancelButton}
      headerMessage={modalMessages.modalTitle}
      isActionDisabled={actionButtonDisabled}
      onAction={onConfirm}
      onCancel={onClose}
      onClose={onClose}
      size='medium'
    >
      <>
        <Text className={style['modal-content-title']} element='h3' textType={TextType.H3} value={modalMessages.bodyTitle} />
        <Text element='p' textType={TextType.Paragraph} value={modalMessages.bodyContent} />
      </>
    </SimpleModal>
  );
};
